import { IonText } from "@ionic/react";
import { DetailedHTMLProps, HTMLAttributes } from "react";

import styles from "@components/typography/Typography.module.css";
import { Colors } from "@utils/colorUtils";

type Props = DetailedHTMLProps<HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> & {
  color?: Colors;
};

const Heading4 = ({ children, color = "primary-300", ...headingProps }: Props) => (
  <h4 className={styles.heading4} {...headingProps}>
    <IonText color={color}>{children}</IonText>
  </h4>
);

export default Heading4;
